import script from "./ShopGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopGroup.vue?vue&type=script&lang=ts&setup=true"

import "./ShopGroup.vue?vue&type=style&index=0&id=21ab7e46&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ab7e46"]])

export default __exports__